import React, { useState } from 'react';
import { Box, Typography, Button, Alert, CircularProgress } from '@mui/material';
import { sendEmailVerification } from 'firebase/auth';
import { auth } from '../../firebase/firebaseConfig';
import { useNavigate } from 'react-router';

const VerificationRequest = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleSendVerification = async () => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const currentUser = auth.currentUser;
      
      if (!currentUser) {
        setError('No user is currently signed in. Please sign in again.');
        return;
      }

      await sendEmailVerification(currentUser);
      setSuccess(true);
    } catch (err: any) {
      console.error('Error sending verification email:', err);
      setError(err.message || 'Failed to send verification email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', p: 3, textAlign: 'center' }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Email Verification Required
      </Typography>

      {success && (
        <Alert severity="success" sx={{ mb: 3 }}>
          Verification email sent successfully! Please check your inbox.
        </Alert>
      )}

      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      <Typography paragraph>
        Your email address has not been verified yet. Please check your inbox for a verification email and click the
        verification link.
      </Typography>

      <Typography paragraph sx={{ mb: 4 }}>
        If you don't see the email, check your spam folder or click the button below to send a new verification email.
      </Typography>

      <Typography paragraph sx={{ mb: 4 }}>
        If you've verified your email, wait a few moments and tap the button below.
      </Typography>

      <Button variant="text" color="primary" onClick={() => navigate('/sign-in')} sx={{ mt: 2 }}>
        Go to dashboard / sign in
      </Button>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSendVerification}
          disabled={loading}
          sx={{ minWidth: 200, alignSelf: 'center' }}
        >
          {loading ? <CircularProgress size={24} /> : 'Resend Verification Email'}
        </Button>
      </Box>
    </Box>
  );
};

export default VerificationRequest;
